import React, { ReactNode } from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Stack } from '@fiverr-private/layout_components';
import { Heading, Text } from '@fiverr-private/typography';
import { CalendarTimelineIcon, ClockIcon, DurationIcon, ReturningIcon, TagIcon } from '@fiverr-private/visuals';

type ItemCategory = 'budget' | 'timeline';

type ItemTitle =
  | 'hourly_rates'
  | 'fixed_price'
  | 'hiring_duration'
  | 'time_commitment'
  | 'delivery_timeline'
  | 'frequency';

const icons = {
  budget: <TagIcon />,
  duration: <DurationIcon />,
  commitment: <ClockIcon />,
  delivery: <CalendarTimelineIcon />,
  frequency: <ReturningIcon />,
};

export const BudgetAndTimelineItem = (props: {
  type: ItemCategory;
  title: ItemTitle;
  iconName: string;
  children: ReactNode;
}) => {
  const { type, title, iconName, children } = props;

  return (
    <Stack direction="column" gap="1">
      <Stack direction="row" gap="2" alignItems="center">
        {icons[iconName]}
        <Heading size="h_xxs" whiteSpace="nowrap">
          <I18n k={`brief_preview_drawer.person_brief.${type}.${title}.title`} />
        </Heading>
      </Stack>
      <Text size="b_md" whiteSpace="nowrap">
        {children}
      </Text>
    </Stack>
  );
};
